var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{attrs:{"content-class":"mt-3","lazy":""}},[_c('b-tab',{attrs:{"title":"Company Configuration"}},[_c('CompanyConfiguration')],1),_c('b-tab',{attrs:{"title":"Bank Accounts"}},[_c('BankAccounts')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }